
import { Record } from "../../../fable_modules/fable-library-js.5.0.0/Types.js";
import { record_type, option_type, class_type } from "../../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import React from "react";
import * as react from "react";
import { map } from "../../../fable_modules/fable-library-js.5.0.0/Option.js";
import { FSharpMap__TryFind } from "../../../fable_modules/fable-library-js.5.0.0/Map.js";
import { DateRangeDualTextInput } from "@stenajs-webui/calendar";

export class DateRange extends Record {
    constructor(startDate, endDate) {
        super();
        this.startDate = startDate;
        this.endDate = endDate;
    }
}

export function DateRange_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Components.StenaWebUI.Calendar.DateRange", [], DateRange, () => [["startDate", option_type(class_type("System.DateTime"))], ["endDate", option_type(class_type("System.DateTime"))]]);
}

export function DateRangeDualTextInputModule_View($props) {
    const p = $props.p;
    let props;
    const disabled = map((x) => x, FSharpMap__TryFind(p, "disabled"));
    const value = map((x_1) => x_1, FSharpMap__TryFind(p, "value"));
    const onValueChange = map((x_2) => x_2, FSharpMap__TryFind(p, "onValueChange"));
    const minDate = map((x_3) => x_3, FSharpMap__TryFind(p, "minDate"));
    props = {
        disabled: disabled,
        maxDate: map((x_4) => x_4, FSharpMap__TryFind(p, "maxDate")),
        minDate: minDate,
        onValueChange: onValueChange,
        value: value,
    };
    return react.createElement(DateRangeDualTextInput, props);
}

